import * as api from './client';

window.Ya = window.Ya || {};
window.Ya.Divkit = window.Ya.DivKit = api;
